module.exports = __webpack_public_path__ + "static/pagerduty-d1d426a36640ab716bab27171994b964.svg";